import { injectMediaAPI } from '../../api/interface/bind';
import type { IAuthenticationManager } from '../../controller/interface/auth';
import type { IContainer } from '../../interface/container';
import type { IProgressPromise } from '../../interface/promise';
import { injectProgressPromise } from '../../interface/promise';
import type { IMediumDto } from '../../model';
import download from './download';

function downloadMedia(
    container: IContainer,
): (
    media: Array<IMediumDto | string>,
    auth: IAuthenticationManager,
) => IProgressPromise<Array<Blob>> {
    const promiser = injectProgressPromise(container);
    const mediaAPI = () => injectMediaAPI(container);

    return (media: Array<IMediumDto | string>, auth: IAuthenticationManager) =>
        download(promiser, mediaAPI, 'Blob', media, auth);
}

function downloadMediaNoResponse(
    container: IContainer,
): (
    media: Array<IMediumDto | string>,
    auth: IAuthenticationManager,
) => IProgressPromise<Array<void>> {
    const promiser = injectProgressPromise(container);
    const mediaAPI = () => injectMediaAPI(container);

    return (media: Array<IMediumDto | string>, auth: IAuthenticationManager) =>
        download(promiser, mediaAPI, 'none', media, auth);
}

const module = {
    downloadMedia,
    downloadMediaNoResponse,
};

export default module;
